module.exports = __webpack_public_path__ + "img/crush_light_ba_detail_rsh_2.9ac19267.jpg";